import { useMocks } from '../../shared/env';
import type { DashboardGateway } from './DashboardGateway';
import { HttpDashboardGateway } from './HttpDashboardGateway';
import { MockDashboardGateway } from './MockDashboardGateway';

export const dashboardGateway: DashboardGateway = useMocks ? new MockDashboardGateway() : new HttpDashboardGateway();

export * from './types';
export type { DashboardGateway } from './DashboardGateway';
